import React, { FC, Fragment } from 'react'
import { plural, Trans } from '@lingui/macro'

import Loader from '../../../../../components/common/loader/Loader'
import { useGroupsWithUserCountsQuery } from './GroupFilterHumanizer.codegen'
import { CampaignFilter } from 'front-end/src/graphql/private/PrivateSchemaTypes'

export const useGroupsWithUserCountsQueryCached = () => {
  return useGroupsWithUserCountsQuery({
    fetchPolicy: 'cache-first'
  })
}

export const GroupFilterHumanizer: FC<CampaignFilter> = (filter) => {
  const { data: groupsQueryResponse, loading } =
    useGroupsWithUserCountsQueryCached()
  if (loading) {
    return <Loader />
  }

  const filterGroups = groupsQueryResponse?.groups.filter((g) =>
    filter.ref_ids?.includes(g.id)
  )
  return (
    <>
      <span>
        <Trans>Is a member of the</Trans>{' '}
      </span>
      {filterGroups?.map((g, index) => {
        return (
          <Fragment key={g.id}>
            <strong key={g.id}>{g.name}</strong>
            {index === filterGroups.length - 1 ? null : (
              <span key={`${g.id}comma`}>, </span>
            )}
          </Fragment>
        )
      })}{' '}
      <span>
        {plural(filterGroups?.length ?? 0, {
          one: 'group',
          other: 'groups'
        })}
      </span>
    </>
  )
}
